import React from 'react';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';
import {connect} from 'react-redux';
import {Permissioned} from 'react-permissions';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import Util from '../../../util/util';
import Messages from '../../../configurations/messages';
import Permissions from '../../../configurations/permissions';
import Constants from '../../../configurations/constants';
import ScriptsApi from '../../../api/ScriptsApi';
import ScriptsTable from './scriptsTable';
import ScriptsModal from './scriptsModal';




class ScriptsPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            scripts: [],
            selectedScript: null,
            totalCount: 0,
            loading: false,
            pages: 0,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum: 0, //Zero based index
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
    }

    componentDidMount() {
        //Load data on mount
       this.reloadScripts();
    }

    render() {
        return (

            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Scripts" />
                <Divider />
                <ScriptsTable
                    onRowClick={this.onRowClick}
                    loading={this.state.loading}
                    onTableChange={this.onTableChange}
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    scripts={this.state.scripts}
                />
                {this.state.selectedScript &&
                    <ScriptsModal  isOpen={this.state.selectedScript != null} onRequestClose={this.handleCloseModal}  script={this.state.selectedScript} />
                }
            </div>
        )
    }


    onTableChange(state, instance) {
        let pageSize = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
            let params = Util.clone(this.state.filterParams);
            params.pageSize = pageSize;
            params.pageNum = pageNum + 1;

            this.loadScripts(params);
        }

    }

    loadScripts(params, resetPageNumber) {
        //Reset states 
        let stateUpdate = { loading: true, scripts: [] };
        if (resetPageNumber) {
            stateUpdate.pageNum = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || (this.state.pageNum + 1);


        ScriptsApi.getScripts(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Scripts")
                this.setState({ scripts: data, loading: false, filterParams: params, totalCount: totalCount, pages: pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_SCRIPTS} -${error.data ? error.data.description : error.statusText}`, `${error.status}`);
                this.setState({ loading: false });
            });
    }

    onRowClick(index) {
        this.setState({ selectedScript: this.state.scripts[index] });
    }
    handleCloseModal(event, reloadDataFlag) {
        this.setState({ selectedScript: null });
        if (reloadDataFlag) {
            this.reloadScripts();
        }
    }

    reloadScripts() {
        this.loadScripts({ pageSize: this.state.pageSize });
    }

}

export default connect(Util.defaultMapStateToProps)(Permissioned(ScriptsPage, [Permissions.VIEW_SCRIPT]));


// WEBPACK FOOTER //
// ./src/components/admin/scripts/scriptsPage.js